import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVariant10 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m8.845 13.72 1.06 1.06L15.685 9l-5.78-5.78-1.06 1.06 3.97 3.97H2.25v1.5h10.564z"
	})
});
export default SvgVariant10;
